// src/firebase-config.js
import { initializeApp, getApps, getApp } from "firebase/app";
import {
  getAuth,
  initializeAuth,
  inMemoryPersistence,
  indexedDBLocalPersistence,
  browserLocalPersistence,
  browserSessionPersistence,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions /*, connectFunctionsEmulator */ } from "firebase/functions";
import { getStorage } from "firebase/storage";

// --- your existing config (unchanged) ---
const firebaseConfig = {
  apiKey: "AIzaSyDWKpgkcNOGoY5PC0vL_2eDLERvdWqp3p0",
  authDomain: "integrity-resolutions-inc.firebaseapp.com",
  projectId: "integrity-resolutions-inc",
  storageBucket: "integrity-resolutions-inc.firebasestorage.app",
  messagingSenderId: "774073159618",
  appId: "1:774073159618:web:2e78b638ab75f7293d905b",
  measurementId: "G-9E0N15FRDT",
  databaseId: "clientinformation",
};

// Single app instance
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// ---- Heuristics to avoid IndexedDB in portal / flaky browsers ----
const onPortal =
  typeof window !== "undefined" && window.location.pathname.startsWith("/portal");

// Very conservative probe for IndexedDB flakiness (Safari private mode, etc.)
const idbProbablyBroken =
  typeof window !== "undefined" &&
  (!("indexedDB" in window) ||
    (() => {
      try {
        const req = window.indexedDB.open("__fb_idb_probe__", 1);
        // not perfect, but avoids throwing synchronously
        req.onerror = () => {};
        return false;
      } catch {
        return true;
      }
    })());

const forceMemory = onPortal || idbProbablyBroken;

// ---- Auth: initialize once with chosen persistence ----
let auth;
try {
  // If someone already called getAuth(app) elsewhere, this will succeed.
  auth = getAuth(app);
} catch {
  // no-op; we'll initialize below
}
if (!auth || !auth.app) {
  auth = initializeAuth(app, {
    // In portal / flaky IDB: memory-only. Else: your original multi-layer fallback.
    persistence: forceMemory
      ? [inMemoryPersistence]
      : [indexedDBLocalPersistence, browserLocalPersistence, browserSessionPersistence],
  });
}

// ---- Firestore: keep your named database ("clientinformation") ----
// Using getFirestore(app, dbId) to preserve your existing DB name.
// (We are NOT enabling persistent IndexedDB cache here.)
const db = getFirestore(app, firebaseConfig.databaseId);

// ---- Storage & Functions (unchanged) ----
const storage = getStorage(app);
const functions = getFunctions(app, "us-central1");

// // (Optional) Local Dev: Uncomment for emulator use
// connectFunctionsEmulator(functions, "localhost", 3000);

export { db, auth, app, functions, storage };